module.exports = __webpack_public_path__ + "2362e0c7752df372147777a6c4db3e37.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/edit.svg
// module id = 48
// module chunks = 0